module.exports = __webpack_public_path__ + "static/media/userProfileSuccess.94680331.svg";